<template>
    <div id="loading">

        <span class="logo"></span>

        <div class="list-container">

            <h2 id="title" @click="openErrorDetails">{{ txtInit }}<span :class="{pointSynchro1: !enErreur}">.</span><span :class="{pointSynchro2: !enErreur}">.</span><span :class="{pointSynchro3: !enErreur}">.</span></h2>

            <div class="actions-erreur" v-if="enErreur">
                <a class="btn btn-full" href="javascript: void 0" @click.prevent="reessayer">Réessayer</a>
                <a class="btn btn-wire" href="javascript: void 0" @click.prevent="$router.push({name: 'home'})">Accueil</a>
            </div>

            <ul class="item-list">
                <li id="synchro_detenteur">
                    Téléchargement des détenteurs et installations
                    <span class="loaderSpin"></span>
                    <span class="check-mark hide">&#10004;</span>
                </li>

                <li id="synchro_bouteille">
                    Téléchargement des bouteilles
                    <span class="loaderSpin"></span>
                    <span class="check-mark hide">&#10004;</span>
                </li>

                <li id="synchro_profil">
                    Téléchargement du profil utilisateur
                    <span class="loaderSpin"></span>
                    <span class="check-mark hide">&#10004;</span>
                </li>

                <li id="synchro_outils">
                    Téléchargement des outillages
                    <span class="loaderSpin"></span>
                    <span class="check-mark hide">&#10004;</span>
                </li>

                <li id="synchro_distri">
                    Téléchargement des distributeurs
                    <span class="loaderSpin"></span>
                    <span class="check-mark hide">&#10004;</span>
                </li>

                <li id="synchro_fluides">
                    Téléchargement des fluides
                    <span class="loaderSpin"></span>
                    <span class="check-mark hide">&#10004;</span>
                </li>

                <li id="synchro_op_bouteille">
                    Téléchargement des opérations bouteille
                    <span class="loaderSpin"></span>
                    <span class="check-mark hide">&#10004;</span>
                </li>

                <li id="synchro_otags">
                    Téléchargement des Otags
                    <span class="loaderSpin"></span>
                    <span class="check-mark hide">&#10004;</span>
                </li>

                <li id="synchro_divers">
                    Autres téléchargements
                    <span class="numberDivers">{{ this.completedSteps }}/{{ this.totalSteps }}</span>
                    <span class="check-mark hide">&#10004;</span>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>

    import RadialProgressBar from 'vue-radial-progress'
    import Initialisation from '../../js/core/Initialisation.js'
    import Offline from '../../js/models/Offline'
    import Security from '../../js/core/Security'

    export default {
        data() {
            return {
                completedSteps: 0,
                // 16 depuis la suppression de l'étape Agenda / Planning (MD-667) :
                // une étape de moins incrémente completedSteps, la barre doit
                // pouvoir atteindre son total.
                totalSteps: 16,
                stopColor: "#2171b7",
                startColor: "#a4cdf3",
                txtInit : "Téléchargement en cours",
                errorInfo: "",
                enErreur: false,
                clicked: 0
            }
        },
        components: {
            RadialProgressBar
        },
        methods: {

            // MD-565 : GET /me refuse l'acces (evaluation terminee, operateur
            // desactive). On purge la session — y compris le hash du mot de
            // passe, sinon le chemin hors-ligne de Login.vue laisserait
            // rentrer le compte — puis on explique avant de renvoyer au login.
            deconnecterSurRefus(refus) {
                const router = this.$router;

                Security.logoutRefus(function() {
                    // sweetalert2 6.x rejette sur esc/clic exterieur : sans
                    // handler de rejet l'utilisateur resterait sur le spinner.
                    const versLogin = function() { router.push('login'); };
                    swal('Accès refusé', Security.libelleRefus(refus), 'error')
                        .then(versLogin, versLogin);
                });
            },


            changeStatus(id) {
                let ligne = document.getElementById(id);
                ligne.querySelector('.loaderSpin').classList.add('hide');
                ligne.querySelector('.check-mark').classList.remove('hide');
            },

            reessayer() {
                // Un rechargement complet coupe les requêtes encore en vol de la tentative ratée,
                // qui sinon écriraient dans localforage pendant la nouvelle tentative.
                window.location.reload();
            },

            openErrorDetails() {
                this.clicked++;
                if(this.errorInfo !== "" && this.clicked === 3) {
                    this.clicked = 0;
                    swal({
                        title: "Une erreur est survenue",
                        html: this.errorInfo + '<br> Vous pouvez contacter le support technique à l\'adresse suivante : <a href="mailto:support@mobiledev-pro.fr">support@mobiledev-pro.fr</a>',
                        type: "error",
                        confirmButtonText: "Fermer"
                    });
                }
            },

            loadData() {
                let vue = this;

                Offline
                    .getList()
                    .then(res => {

                        let router = this.$router;

                        if (res === null || res.length === 0) {

                                localforage
                                    .getItem('api-token')
                                    .then(key => {

                                        if (!key) {
                                            localforage.removeItem('lastConnexion').then(() => router.push('login'));
                                            return;
                                        }

                                        axios.get(urlAPI + '/me', { headers: { 'Authorization': 'Bearer ' + key } })
                                            .then(() => {

                                        let api = new Initialisation(key);

                                        const initDetenteurPromise = api.initDetenteursAndInstall().then(function() {
                                            vue.changeStatus('synchro_detenteur');
                                        });


                                        const otherInitializations = [
                                            api.initOfflineActions().then(function() {
                                                vue.completedSteps += 1;
                                            }),
                                            api.initBouteilles().then(function(){
                                                vue.changeStatus('synchro_bouteille');
                                            }),
                                            api.initProfil().then(function(){
                                                vue.completedSteps += 1;
                                            }),
                                            api.initUsers().then(function(){
                                                vue.changeStatus('synchro_profil');
                                            }),
                                            api.initOutils().then(function(){
                                                vue.completedSteps += 1;
                                            }),
                                            api.initFournisseurs().then(function(){
                                                vue.changeStatus('synchro_distri');
                                            }),
                                            api.initFluides().then(function(){
                                                vue.changeStatus('synchro_fluides');
                                            }),
                                            api.initNomsBouteilles().then(function(){
                                                vue.completedSteps += 1;
                                            }),
                                            api.initAssemblages().then(function () {
                                                vue.completedSteps += 1;
                                            }),
                                            Promise.all([
                                                api.initFuites().then(function () {
                                                    vue.completedSteps += 1;
                                                }),
                                                api.initPieces().then(function () {
                                                    vue.completedSteps += 1;
                                                }),
                                                api.initPhotosFiche().then(function () {
                                                    vue.completedSteps += 1;
                                                })
                                            ]).then(function () {
                                                return api.initFibsdds().then(function () {
                                                    vue.completedSteps += 1;
                                                });
                                            }),
                                            api.initDistributeurs().then(function(){
                                                vue.completedSteps += 1;
                                            }),
                                            api.initTransporteurs().then(function(){
                                                vue.completedSteps += 1;
                                            }),
                                            api.initOperations().then(function(){
                                                vue.changeStatus('synchro_op_bouteille');
                                            }),
                                            api.initTypesOutil().then(function (){
                                                vue.changeStatus('synchro_outils');
                                            }),
                                            api.initTypesOperation().then(function(){
                                                vue.completedSteps += 1;
                                            }),
                                            api.initScans().then(function(){
                                                vue.completedSteps += 1;
                                            }),
                                            api.initOtags().then(function(){
                                                vue.changeStatus('synchro_otags');
                                            }),
                                            api.initOptions().then(function(){
                                                vue.completedSteps += 1;
                                            }),
                                            api.initOthersApi().then(function() {
                                                vue.completedSteps += 1;
                                            }),
                                            api.getLastsDetenteurs(),
                                            api.requestTD().then(function () {
                                                vue.completedSteps += 1;
                                            }),
                                            api.getInformationBouteille()
                                        ]


                                        return Promise.all([initDetenteurPromise, ...otherInitializations]).then(
                                            () => {
                                                setTimeout(function () {
                                                    const pending = sessionStorage.getItem('pendingRedirectAfterLogin');
                                                    if (pending) {
                                                        sessionStorage.removeItem('pendingRedirectAfterLogin');
                                                        router.push(pending);
                                                    } else {
                                                        router.push('home');
                                                    }
                                                },100)
                                            }
                                        ).catch(err => {
                                            const refus = Security.refusDepuisErreur(err);
                                            if (refus) {
                                                return vue.deconnecterSurRefus(refus);
                                            }

                                            if(typeof err.response != "undefined" && err.response.status === 403) {
                                                localforage.removeItem('lastConnexion').then(() => {
                                                    router.push('login')
                                                })
                                            }else{
                                                vue.completedSteps = 0
                                            }

                                            if(err) {
                                                vue.enErreur = true;
                                                vue.txtInit = "Une erreur est survenue"
                                                vue.errorInfo = err
                                            }
                                        })

                                    }) // fin .then() test token
                                            .catch(err => {
                                                // MD-565 : sans la branche 403 le
                                                // spinner tournait indefiniment pour un
                                                // compte refuse.
                                                const refus = Security.refusDepuisErreur(err);
                                                if (refus) {
                                                    return vue.deconnecterSurRefus(refus);
                                                }

                                                if (err.response && err.response.status === 401) {
                                                    localforage.removeItem('lastConnexion').then(() => router.push('login'));
                                                    return;
                                                }

                                                // Arreter les points animes, sinon ils
                                                // tournent a cote du message d'erreur et
                                                // laissent croire au chargement.
                                                vue.enErreur = true;
                                                vue.txtInit = "Une erreur est survenue";
                                                vue.errorInfo = err;
                                            });

                                    }).catch()


                        } else {
                            const getRedirect = () => {
                                const pending = sessionStorage.getItem('pendingRedirectAfterLogin');
                                if (pending) {
                                    sessionStorage.removeItem('pendingRedirectAfterLogin');
                                    return pending;
                                }
                                return 'home';
                            };
                            swal(
                                'Données non synchronisées',
                                "Veuillez synchroniser vos données hors ligne au plus vite.",
                                'warning'
                            ).then(
                                () => router.push(getRedirect()),
                                () => router.push(getRedirect())
                            )

                        }

                    })
                    .catch()

            }
        },
        async mounted() {
            if (window.location.hash === "#/init") {
                window.location = window.location + '#maj';

                if (window.flutter_inappwebview !== undefined) {
                    await window.flutter_inappwebview.callHandler('handlerIsNew');
                }

                window.wantReload();

            }else{
                this.loadData();
            }

        }
    }

</script>

<style scoped>
    h2 {
        position: relative;
        font-size: 24px;
        color: #333;
        margin-bottom: 10px;
        font-weight: bold;
    }

    img {
        display: block;
        margin: auto;
        width: 250px;
        margin-top: 50px;
        margin-bottom: 60px;
    }

    p.info-dl {
        text-align: center;
        width: 175px;
    }

    .actions-erreur {
        display: flex;
        margin-bottom: 10px;
    }

    .actions-erreur .btn {
        flex: 1;
        align-items: center;
        margin: 0 5px;
    }

    .list-container {
        position: relative;
        max-width: 400px;
        margin: 0 auto;
    }

    .item-list {
        list-style-type: none;
        padding: 0;
    }

    .item-list li {
        position: relative; /* Ajoutez cette ligne pour positionner les loaders */
        margin: 10px 0;
        padding: 5px;
        background-color: #f5f5f5;
    }

    .loaderSpin {
        position: absolute;
        top: 7px;
        right: 5px; /* Ajustez cette valeur selon vos besoins */
        transform: translateY(-50%);
        border: 4px solid black;
        border-top: 4px solid #3498db;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        animation: spin 2s linear infinite;
    }

    .check-mark {
        position: absolute;
        top: 0;
        right: 3px;
        font-size: 25px;
        color: #00cc00;
    }

    .numberDivers {
        position: absolute;
        top: 7px;
        right: 28px; /* Ajustez cette valeur selon vos besoins */
        width: 20px;
        height: 20px;
    }

    .pointSynchro1, .pointSynchro2, .pointSynchro3 {
        display: inline-block;
    }

    .pointSynchro1{
        animation: bounce 1s ease-in-out infinite;
    }

    .pointSynchro2{
        animation: bounce 1s ease-in-out 0.33s infinite;
    }

    .pointSynchro3{
        animation: bounce 1s ease-in-out 0.66s infinite;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    @keyframes bounce{
        0%, 75%, 100%{
            -webkit-transform: translateY(0);
            -ms-transform: translateY(0);
            -o-transform: translateY(0);
            transform: translateY(0);
        }

        25%{
            -webkit-transform: translateY(-20px);
            -ms-transform: translateY(-20px);
            -o-transform: translateY(-20px);
            transform: translateY(-20px);
        }
    }
</style>



// WEBPACK FOOTER //
// InitLoading.vue?31f0dbb1